// extracted by mini-css-extract-plugin
module.exports = {"ErrorContainer":"Page_ErrorContainer__w_9id","ErrorTitle":"Page_ErrorTitle__Na2QA","ErrorMessage":"Page_ErrorMessage__eqUFX"};